import React, { useEffect, useState } from 'react';
import '../../assets/css/Home/Guilds.css';
import { useNavigate } from 'react-router-dom';

const Guilds = () => {
    const [guilds, setGuilds] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchGuilds = async (retryCount = 0) => {
        try {
            const uCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith('u='))
                ?.split('=')[1];

            const htrCookie = document.cookie
                .split('; ')
                .find(row => row.startsWith('htr='))
                ?.split('=')[1];

            if (!uCookie || !htrCookie) {
                throw new Error('Missing required cookies');
            }

            const response = await fetch('https://jaquesbot.fr/api/V4/botConfig/intraConnect/panelAuth/guilds', {
                method: 'POST',
                headers: {
                    'htr': htrCookie,
                    'u': uCookie
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setGuilds(data);
            setLoading(false);
            setError(null);
        } catch (err) {
            if (retryCount < 4) {
                setTimeout(() => fetchGuilds(retryCount + 1), 2000);
            } else {
                setError(err.message);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchGuilds();
    }, []); // Empty dependency array ensures this runs only once

    const filteredGuilds = guilds.filter(guild =>
        guild.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="loading">Loading...</div>;
    if (error) return <div className="error">Error: {error}</div>;

    return (
        <div className="content">
            <h1 className="title">Select a server</h1>
            <div className="search-filter">
                <input 
                    type="text" 
                    placeholder="Search by name" 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <select>
                    <option value="all">All Servers</option>
                </select>
            </div>
            <div className="server-list">
                {filteredGuilds.map((server) => (
                    <div 
                        key={server.id} 
                        className="server-card" 
                        onClick={() => navigate(`/dashboard/g/${server.id}`)} 
                        role="button" 
                        tabIndex="0" 
                        onKeyPress={(e) => { if (e.key === 'Enter') navigate(`/dashboard/g/${server.id}`); }}
                    >
                        <img 
                            draggable="false"
                            src={server.icon ? `https://cdn.discordapp.com/icons/${server.id}/${server.icon}.webp` : 'https://cdn.jaquesbot.app/~/s.png'} 
                            alt={server.name} 
                        />
                        <p>{server.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Guilds;
